import { render, staticRenderFns } from "./BlockWeatherWidget.vue?vue&type=template&id=0f5f02f2"
import script from "./BlockWeatherWidget.vue?vue&type=script&lang=ts"
export * from "./BlockWeatherWidget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports